export const ru = {
    nothing_found: 'Ничего не найдено',
};
